import { render } from "./QuizResultPage.vue?vue&type=template&id=03c317d2&scoped=true&ts=true"
import script from "./QuizResultPage.vue?vue&type=script&lang=ts"
export * from "./QuizResultPage.vue?vue&type=script&lang=ts"

import _style_0 from "./QuizResultPage.vue?vue&type=style&index=0&id=03c317d2&inline&scoped=true&lang=scss"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]],['__scopeId',"data-v-03c317d2"]])

export default __exports__